import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, message, Card } from 'antd';
import axios from '../api/axios';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await axios.post('/auth/login', values);
            localStorage.setItem('token', res.data.access_token);
            message.success('Успешный вход!');
            navigate('/');
        } catch (err) {
            message.error('Неверный номер или пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <Card title="Вход в админку" className="w-full max-w-md shadow-lg">
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item label="Телефон" name="phone" rules={[{ required: true }]}>
                        <Input placeholder="+998..." />
                    </Form.Item>
                    <Form.Item label="Пароль" name="password" rules={[{ required: true }]}>
                        <Input.Password />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Войти
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
